"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiPermissionSelect = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var core_1 = require("@material-ui/core");
var styles_1 = __importDefault(require("./styles"));
var MultiPermissionSelect = function (_a) {
    var testId = _a.testId, options = _a.options, _b = _a.isEditing, isEditing = _b === void 0 ? false : _b, onChange = _a.onChange, rest = __rest(_a, ["testId", "options", "isEditing", "onChange"]);
    var classes = (0, styles_1.default)();
    // const [values, setValues] = useState<IMultiPermissionSelectOptions[]>(options);
    var changeHandler = function (event, selection) {
        var mappedValues = options.map(function (_a) {
            var key = _a.key, value = _a.value, label = _a.label;
            return ({
                value: key === selection.key ? !selection.value : value,
                key: key,
                label: label,
            });
        });
        // setValues(mappedValues);
        onChange(event, { values: mappedValues });
    };
    return isEditing ? ((0, jsx_runtime_1.jsx)(core_1.Select, __assign({ displayEmpty: true, disableUnderline: true, "data-testid": testId, className: classes.multiSelect, multiple: true, value: options, renderValue: function (selected) {
            if (!selected.some(function (item) { return item.value === true; })) {
                return 'None';
            }
            return options
                .filter(function (item) { return item.value; })
                .map(function (item) { return item.label; })
                .join(', ');
        }, input: (0, jsx_runtime_1.jsx)(core_1.Input, {}) }, rest, { children: options.map(function (_a) {
            var label = _a.label, value = _a.value, key = _a.key;
            return ((0, jsx_runtime_1.jsx)(core_1.MenuItem, __assign({ className: classes.displayBlock }, { children: (0, jsx_runtime_1.jsx)(core_1.FormControlLabel, { className: classes.displayBlock, disabled: options.filter(function (option) { return option.value; }).length > 1 && key === 'canView', control: (0, jsx_runtime_1.jsx)(core_1.Checkbox, { color: "primary", checked: value, onChange: function (event) { return changeHandler(event, { label: label, value: value, key: key }); }, inputProps: { 'aria-labelledby': key } }), label: label }) }), key));
        }) }))) : (
    // TODO: useCallback
    (0, jsx_runtime_1.jsx)("div", { children: !options.some(function (item) { return item.value === true; })
            ? 'None'
            : options
                .filter(function (item) { return item.value; })
                .map(function (item) { return item.label; })
                .join(', ') }));
};
exports.MultiPermissionSelect = MultiPermissionSelect;
